// extracted by mini-css-extract-plugin
export default {"displayText":"DwedagwSML","title":"wYiYS3KPP3","colourName":"CI6GICT9W9","colourList":"B8zs1VVNh5","colourItem":"lmZUVzq18T","colourDisclaimer":"bP6JWq5erz"};